import React, { Fragment, useState, useContext } from 'react';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import ACDictionaryTree from './ACDictionaryTree';
import AutocodeSelectionBox from './AutocodeSelectionBox/AutocodeSelectionBox';
import {
  searchDictionaryTree,
  getDictionaryTreeLoad,
  getTemplateData,
} from '../../actions/autocodeActions';
import ACDictionaryContext from './ACContext/ACDictionaryContext';
import ACTemplate1BrandTypeKindForm from './AutocodeDictionary/Templates/ACTemplate1BrandTypeKindForm';
import ACTemplate1Category from './AutocodeDictionary/Templates/ACTemplate1Category';
import ACTemplate1dot1 from './AutocodeDictionary/Templates/ACTemplate1dot1';
import ACTemplate2 from './AutocodeDictionary/Templates/ACTemplate2';
import ACTemplate3 from './AutocodeDictionary/Templates/ACTemplate3';
import ACTemplate4 from './AutocodeDictionary/Templates/ACTemplate4';
import ACTemplate5 from './AutocodeDictionary/Templates/ACTemplate5';
import ACTemplate7 from './AutocodeDictionary/Templates/ACTemplate7';
import ACTemplate8 from './AutocodeDictionary/Templates/ACTemplate8';
import ACTemplate9 from './AutocodeDictionary/Templates/ACTemplate9';
import {
  AC_RECTYPE_Q,
  AC_RECTYPE_S,
  AC_RECTYPE_T,
  TEMPLATE_TYPE_1,
  TEMPLATE_TYPE_1_1,
  TEMPLATE_TYPE_2,
  TEMPLATE_TYPE_3,
  TEMPLATE_TYPE_4,
  TEMPLATE_TYPE_5,
  TEMPLATE_TYPE_6,
  TEMPLATE_TYPE_7,
  TEMPLATE_TYPE_8,
  TEMPLATE_TYPE_9,
} from './AutocodeConstants';
import ACSelectionBoxContext from './ACContext/ACSelectionBoxContext';
import AutocodeSelectionAction from './AutocodeSelectionBox/AutocodeSelectionActions';
import { saveTrackingData } from '../../util/trackerUtils';
import { CO1_SEARCH, COMPOSER_SUBMODULE } from '../../trackerConstants';

const AutocodeDictionaryTab = ({
  moduleStudy,
  activeAccountId,
  uid,
  selectedWeightType,
  gridData,
  moduleAction,
  menuName,
}) => {
  const [dictionary, setDictionary] = useState([]);
  const [study, setStudy] = useState(moduleStudy);
  const [searchQuery, setSearchQuery] = useState('');
  const [templateType, setTemplateType] = useState();
  const [selectedNodeAnswers, setSelectedNodeAnswers] = useState({});
  const [disableAddButton, setdisableAddButton] = useState(false);
  const [prevSelected, setPrevSelected] = useState('');
  const [checkBlur, setCheckBlur] = useState(true);

  const acSelContext = useContext(ACSelectionBoxContext);
  const {
    clearSelectionBox,
    cancelBulkJoinSetup,
    selectAllNodes,
    selectAllFunctions,
    selectAllOperators,
  } = AutocodeSelectionAction(acSelContext.state, acSelContext.dispatch);

  const clearSelections = e => {
    if (checkBlur && !e.currentTarget.contains(e.relatedTarget)) {
      cancelBulkJoinSetup();
      selectAllNodes(false);
      selectAllFunctions(false);
      selectAllOperators(false);
    }
  };

  React.useEffect(() => {
    if ((!dictionary || dictionary.length === 0) && moduleStudy) {
      getDictionaryTreeLoad(
        uid,
        activeAccountId,
        moduleStudy.pn,
        0,
        'all'
      ).then(response => {
        setDictionary(response);
      });
    }
    // window.addEventListener('onresize', handleResize);
  }, []);

  React.useEffect(() => {
    if (!isEmpty(moduleStudy) && study !== moduleStudy) {
      setSearchQuery('');
      getDictionaryTreeLoad(
        uid,
        activeAccountId,
        moduleStudy.pn,
        0,
        'all'
      ).then(response => {
        setDictionary(response);
        setStudy(moduleStudy);
        setSelectedNodeAnswers({});
        clearSelectionBox();
        setTemplateType(null);
      });
    }
  }, [moduleStudy]);

  const clearSearch = () => {
    setSearchQuery('');
    getDictionaryTreeLoad(
      uid,
      activeAccountId,
      moduleStudy.pn,
      0,
      'all'
    ).then(response => setDictionary(response));
  };

  const searchDictionary = () => {
    // clear search if search query is empty
    if (searchQuery.length > 0) {
      searchDictionaryTree(
        uid,
        activeAccountId,
        moduleStudy.pn,
        '100', // searchType 100 = search all levels of dictionary and include templateType
        searchQuery
      ).then(response => {
        setDictionary(response);
        saveTrackingData({
          uid,
          accid: activeAccountId,
          productNo: moduleStudy.pn,
          moduleName: menuName,
          subModule: COMPOSER_SUBMODULE,
          action: CO1_SEARCH,
          attributes: { searchTerm: searchQuery },
        });
      });
    } else {
      clearSearch();
    }
  };

  const clearPrevSelectedNode = (dictionaryData, index = 0) => {
    const textPathList = prevSelected.split('.');
    textPathList.forEach(() => {
      dictionaryData.map(node => {
        if (node.isSelected) {
          delete node.isSelected;
        } else if (node.children) {
          node = clearPrevSelectedNode(node.children, index + 1);
        }
        return node;
      });
    });
  };

  // node id for treeloadex and search returns is different
  const getNodeId = node => node.node || String(node.recno);

  // traverse tree to set isOpened and set children on clicked node
  const updateACTreeNode = (nodes, children, currentNode) => {
    const updatedNodes = nodes.map(node => {
      if (nodes.some(n => currentNode.textPath.startsWith(n.textPath))) {
        if (getNodeId(node) === getNodeId(currentNode)) {
          if (node.rectype !== AC_RECTYPE_Q) {
            node.isOpened = true;
            node.children = children;
          } else {
            if (prevSelected !== '') {
              clearPrevSelectedNode(dictionary);
            }
            node.isOpened = true;
            node.isSelected = true;
            setPrevSelected(node.textPath);
          }
        } else if (node.rectype === AC_RECTYPE_Q) {
          node.isSelected = false;
        }
      }
      if (node.children) {
        if (node.rectype !== AC_RECTYPE_Q) {
          node.children = updateACTreeNode(
            node.children,
            children,
            currentNode
          );
        }
      }
      return node;
    });
    return updatedNodes;
  };

  // traverse tree to remove isOpened field
  const updateClosedState = (nodes, currentNode) => {
    const updatedNodes = nodes.map(node => {
      if (nodes.some(n => currentNode.textPath.startsWith(n.textPath))) {
        if (getNodeId(node) === getNodeId(currentNode)) {
          delete node.isOpened;
        }
        if (node.children) {
          node.children = updateClosedState(node.children, currentNode);
        }
      }
      return node;
    });
    return updatedNodes;
  };

  // traverse tree to set isSelected field and remove prev selected
  const updateTreeNodeState = (node, dictionaryData, templateType) => {
    dictionaryData.map(ansNode => {
      if (getNodeId(ansNode) === getNodeId(node)) {
        if (
          ansNode.templateType &&
          ansNode.templateType === templateType &&
          (ansNode.rectype === AC_RECTYPE_Q ||
            ansNode.rectype === AC_RECTYPE_T ||
            ansNode.rectype === AC_RECTYPE_S)
        ) {
          switch (templateType) {
            case TEMPLATE_TYPE_1: {
              if (ansNode.rectype === AC_RECTYPE_T) {
                setPrevSelected(ansNode.textPath);
                ansNode.isSelected = true;
              }
              break;
            }
            case TEMPLATE_TYPE_1_1: {
              if (ansNode.rectype === AC_RECTYPE_Q) {
                setPrevSelected(ansNode.textPath);
                ansNode.isSelected = true;
              }
              break;
            }
            case TEMPLATE_TYPE_2: {
              if (
                ansNode.rectype === AC_RECTYPE_T ||
                ansNode.rectype === AC_RECTYPE_S
              ) {
                setPrevSelected(ansNode.textPath);
                ansNode.isSelected = true;
              }
              break;
            }
            case TEMPLATE_TYPE_3: {
              if (ansNode.rectype === AC_RECTYPE_Q) {
                setPrevSelected(ansNode.textPath);
                ansNode.isSelected = true;
              }
              break;
            }
            case TEMPLATE_TYPE_4: {
              if (ansNode.rectype === AC_RECTYPE_T) {
                setPrevSelected(ansNode.textPath);
                ansNode.isSelected = true;
              }
              break;
            }
            case TEMPLATE_TYPE_5: {
              if (ansNode.rectype === AC_RECTYPE_Q) {
                setPrevSelected(ansNode.textPath);
                ansNode.isSelected = true;
              }
              break;
            }
            case TEMPLATE_TYPE_7: {
              if (
                ansNode.rectype === AC_RECTYPE_T ||
                ansNode.rectype === AC_RECTYPE_S
              ) {
                setPrevSelected(ansNode.textPath);
                ansNode.isSelected = true;
              }
              break;
            }
            case TEMPLATE_TYPE_8: {
              if (
                ansNode.rectype === AC_RECTYPE_T ||
                ansNode.rectype === AC_RECTYPE_S
              ) {
                setPrevSelected(ansNode.textPath);
                ansNode.isSelected = true;
              }
              break;
            }
            case TEMPLATE_TYPE_9: {
              if (ansNode.rectype === AC_RECTYPE_Q) {
                setPrevSelected(ansNode.textPath);
                ansNode.isSelected = true;
              }
              break;
            }
            default:
              break;
          }
        }
      } else if (ansNode.children) {
        ansNode = updateTreeNodeState(node, ansNode.children, templateType);
      }

      return ansNode;
    });
  };

  const getSelectedNodeData = (node, templateType) => {
    setTemplateType(null);
    if (prevSelected !== '') {
      clearPrevSelectedNode(dictionary);
    }
    updateTreeNodeState(node, dictionary, templateType);
    getTemplateData(uid, activeAccountId, moduleStudy.pn, getNodeId(node)).then(
      response => {
        setSelectedNodeAnswers(response);
        setTemplateType(response.root.templateType);
      }
    );
  };

  const nodeClickHandler = node => {
    if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_1 &&
      node.rectype === AC_RECTYPE_T
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_1);
    } else if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_1_1 &&
      node.rectype === AC_RECTYPE_Q
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_1_1);
    } else if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_3 &&
      node.rectype === AC_RECTYPE_Q
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_3);
    } else if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_2 &&
      node.rectype === AC_RECTYPE_T
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_2);
    } else if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_2 &&
      node.rectype === AC_RECTYPE_S
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_2);
    } else if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_4 &&
      node.rectype === AC_RECTYPE_T
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_4);
    } else if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_5 &&
      node.rectype === AC_RECTYPE_Q
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_5);
    } else if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_7 &&
      node.rectype === AC_RECTYPE_T
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_7);
    } else if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_7 &&
      node.rectype === AC_RECTYPE_S
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_7);
    } else if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_8 &&
      node.rectype === AC_RECTYPE_T
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_8);
    } else if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_8 &&
      node.rectype === AC_RECTYPE_S
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_8);
    } else if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_9 &&
      node.rectype === AC_RECTYPE_Q
    ) {
      getSelectedNodeData(node, TEMPLATE_TYPE_9);
    } else if (!node.isOpened || node.rectype === AC_RECTYPE_Q) {
      if (node.children !== undefined) {
        const latestState = updateACTreeNode(dictionary, node.children, node);
        setDictionary(latestState);
      } else {
        getDictionaryTreeLoad(
          uid,
          activeAccountId,
          moduleStudy.pn,
          getNodeId(node),
          'all'
        ).then(response => {
          const latestState = updateACTreeNode(dictionary, response, node);
          setDictionary(latestState);
        });
      }
    } else {
      const latestState = updateClosedState(dictionary, node);
      setDictionary(latestState);
    }
  };

  const disableAdd = disableFlag => {
    setdisableAddButton(disableFlag);
  };

  return (
    <ACDictionaryContext.Provider
      value={{ dictionary, selectedNodeAnswers, disableAddButton }}
    >
      <Fragment>
        {/* Hide search bar for later implementation */}
        <div className="autocode-search-input-container">
          <input
            type="text"
            placeholder="Search..."
            className="autocode-search-input"
            value={searchQuery}
            onChange={e => {
              setSearchQuery(e.target.value);
              if (e.target.value.length === 0) clearSearch(); // if query is empty, clear search
            }}
            onKeyDown={e => e.key === 'Enter' && searchDictionary()}
          />
          {searchQuery.length > 0 && (
            <button
              type="button"
              className="autocode-search-input-button"
              onClick={clearSearch}
            >
              <i className="fa fa-times" title="Clear Search" />
            </button>
          )}
        </div>
        <div className="row expanded">
          <div className="columns small-3 medium-3 large-3 autocode-inner-left-col ac-dictionary-first-col">
            <ACDictionaryTree nodeClickHandler={nodeClickHandler} />
          </div>
          <div
            id="middle-category"
            className="columns small-3 medium-3 large-3 autocode-dictionary-inner-middle-col"
          >
            {templateType === TEMPLATE_TYPE_1 &&
              !isEmpty(selectedNodeAnswers) &&
              selectedNodeAnswers.root.shortText === 'Category' && (
                <ACTemplate1Category />
              )}
            {templateType === TEMPLATE_TYPE_1 &&
              !isEmpty(selectedNodeAnswers) && <ACTemplate1BrandTypeKindForm />}
            {templateType === TEMPLATE_TYPE_1_1 &&
              !isEmpty(selectedNodeAnswers) && <ACTemplate1dot1 />}
            {templateType === TEMPLATE_TYPE_2 &&
              !isEmpty(selectedNodeAnswers) && <ACTemplate2 />}
            {templateType === TEMPLATE_TYPE_3 &&
              !isEmpty(selectedNodeAnswers) && <ACTemplate3 />}
            {templateType === TEMPLATE_TYPE_4 &&
              !isEmpty(selectedNodeAnswers) && <ACTemplate4 />}
            {templateType === TEMPLATE_TYPE_5 &&
              !isEmpty(selectedNodeAnswers) && <ACTemplate5 />}
            {templateType === TEMPLATE_TYPE_6 &&
              !isEmpty(selectedNodeAnswers) && <div>template 6</div>}
            {templateType === TEMPLATE_TYPE_7 &&
              !isEmpty(selectedNodeAnswers) && <ACTemplate7 />}
            {templateType === TEMPLATE_TYPE_8 &&
              !isEmpty(selectedNodeAnswers) && <ACTemplate8 />}
            {templateType === TEMPLATE_TYPE_9 &&
              !isEmpty(selectedNodeAnswers) && <ACTemplate9 />}
            {!templateType && (
              <div className="ac--dictionary--no-record ">
                The Section will display answers that you can select for the
                target creation.
              </div>
            )}
          </div>
          <div
            className="columns small-6 medium-6 large-6 autocode-inner-right-col ac-selection-box"
            onBlur={e => {
              clearSelections(e);
            }}
          >
            <AutocodeSelectionBox
              disableAdd={disableAdd}
              moduleStudy={moduleStudy}
              uid={uid}
              selectedWeightType={selectedWeightType}
              ExistingGridData={gridData}
              setCheckBlur={setCheckBlur}
              moduleAction={moduleAction}
            />
          </div>
        </div>
      </Fragment>
    </ACDictionaryContext.Provider>
  );
};

AutocodeDictionaryTab.propTypes = {
  menuName: PropTypes.string,
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
  }).isRequired,
  activeAccountId: PropTypes.number.isRequired,
  uid: PropTypes.number.isRequired,
  selectedWeightType: PropTypes.shape({}),
  moduleAction: PropTypes.shape({}),
  gridData: PropTypes.shape({
    BasesDataGrid: PropTypes.arrayOf(PropTypes.object),
    ColumnsDataGrid: PropTypes.arrayOf(PropTypes.object),
    RowsDataGrid: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default React.memo(AutocodeDictionaryTab);
